const TableInfoModal = ({ isOpen, setIsOpen }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white w-full sm:w-[70%] p-5 rounded-lg shadow-lg relative">
        <button
          onClick={() => setIsOpen(false)}
          className="absolute top-2 right-2 text-gray-600 hover:text-gray-800"
        >
          &#10005;
        </button>
        <h2 className=" font-semibold text-[#8B1818] text-start text-xl">
          Monday, 27 Feb 2025
        </h2>
        <div className="mt-4 flex space-x-4">
          <div className="w-1/2 bg-[#F9FAFB] p-4 rounded-md text-start">
          <div className="flex gap-4 flex-col">
          <p className="font-semibold text-[#8B1818] text-xl text-start">
              Michael Aderson
            </p>
            <div className="flex justify-between">
              <p className="text-gray-600">
                <span className="font-semibold text-[#8B1818]">Job:</span>{" "}
                Electrical Installation
              </p>
              <span
                className="px-2 py-1 text-[#8B1818] text-sm font-medium"
                style={{
                  background: "rgba(139, 24, 24, 0.10)",
                  borderRadius: "9999px",
                }}
              >
                4354
              </span>
            </div>

            <div className="flex justify-between ">
              <p className="text-gray-600">
                <span className="font-semibold text-[#8B1818]">cost:</span>{" "}
                Electrical Installation
              </p>
              <span
                className="px-2 py-1 text-[#8B1818] text-sm font-medium"
                style={{
                  background: "rgba(139, 24, 24, 0.10)",
                  borderRadius: "9999px",
                }}
              >
                4354
              </span>
            </div>


          </div>
           
            <hr className="my-2" />
            <div className="grid grid-cols-3 gap-4">
              <div>
                <div className="text-[#4B5563]">Clockin</div>
                <div className="text-[#09090B]">07:00</div>
              </div>

              <div>
                <div className="text-[#4B5563]">Clockout</div>
                <div className="text-[#09090B]">07:00</div>
              </div>

              <div>
                <div className="text-[#4B5563]">Break</div>
                <div className="text-[#09090B]">07:00</div>
              </div>

              <div>
                <div className="text-[#4B5563]">Per Diem</div>
                <div className="text-[#09090B]">$29</div>
              </div>

              <div>
                <div className="text-[#4B5563]">Daily Wages</div>
                <div className="text-[#09090B]">$863</div>
              </div>

              <div>
                <div className="text-[#4B5563]">Total Hours</div>
                <div className="text-[#09090B]">30</div>
              </div>
            </div>
          </div>
          <div className="w-1/2 bg-[#F9FAFB] p-4 rounded-md text-start">
          <div className="flex gap-4 flex-col">
          <p className="font-semibold text-[#8B1818] text-xl text-start">
              Michael Aderson
            </p>
            <div className="flex justify-between">
              <p className="text-gray-600">
                <span className="font-semibold text-[#8B1818]">Job:</span>{" "}
                Electrical Installation
              </p>
              <span
                className="px-2 py-1 text-[#8B1818] text-sm font-medium"
                style={{
                  background: "rgba(139, 24, 24, 0.10)",
                  borderRadius: "9999px",
                }}
              >
                4354
              </span>
            </div>

            <div className="flex justify-between ">
              <p className="text-gray-600">
                <span className="font-semibold text-[#8B1818]">cost:</span>{" "}
                Electrical Installation
              </p>
              <span
                className="px-2 py-1 text-[#8B1818] text-sm font-medium"
                style={{
                  background: "rgba(139, 24, 24, 0.10)",
                  borderRadius: "9999px",
                }}
              >
                4354
              </span>
            </div>


          </div>
            <hr className="my-2" />

            <div className="grid grid-cols-3 gap-4">
              <div>
                <div className="text-[#4B5563]">Clockin</div>
                <div className="text-[#09090B]">07:00</div>
              </div>

              <div>
                <div className="text-[#4B5563]">Clockout</div>
                <div className="text-[#09090B]">07:00</div>
              </div>

              <div>
                <div className="text-[#4B5563]">Break</div>
                <div className="text-[#09090B]">07:00</div>
              </div>

              <div>
                <div className="text-[#4B5563]">Per Diem</div>
                <div className="text-[#09090B]">$29</div>
              </div>

              <div>
                <div className="text-[#4B5563]">Daily Wages</div>
                <div className="text-[#09090B]">$863</div>
              </div>

              <div>
                <div className="text-[#4B5563]">Total Hours</div>
                <div className="text-[#09090B]">30</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TableInfoModal;
